module.exports = __webpack_public_path__ + "static/media/shopswhite.bdfd8f64.svg";